import React from 'react'
import * as F from 'discada/dist/Form'

export default function LeaseTerm({ item, editValue, index, makeDefault }) {
  return (
    <div className="quote-config-collection-leaseTerm">
      <F.TextField
        size="small"
        // label="Term Label"
        value={item.label}
        onChange={({ target }) => editValue(index, 'label', target.value)}
      />
      <F.TextField
        size="small"
        // label="Term Length (in Months)"
        type="number"
        value={item.value || '0'}
        onChange={({ target }) =>
          editValue(index, 'value', parseInt(target.value, 10))
        }
      />
    </div>
  )
}
